import {z} from "zod"

import {i18n} from "../../../i18n.ts"
import {
  requiredFieldMessage,
  validateNonemptyString,
  validatePassword,
  validatePhoneNumber,
} from "../../../utils/validation.ts"

export const steps = [
  {
    validationSchema: z.object({
      first_name: validateNonemptyString(),
      last_name: validateNonemptyString(),
      phone_number: validatePhoneNumber(),
      country_id: z.number({error: issue => (issue.input === undefined ? requiredFieldMessage : undefined)}).positive(),
      city: validateNonemptyString(),
      businessEntityAgreed: z.literal(true, {error: requiredFieldMessage}),
      resume: z
        .custom<File>()
        .refine(file => file instanceof File, {
          message: i18n.t("SalespersonProfile_Profile_Resume_Required"),
        })
        .refine(file => {
          return !file || file.size < 10_000_000
        }, i18n.t("SalespersonProfile_Profile_Resume_LargeFile")),
    }),
  },
  {
    validationSchema: z.object({
      password: validatePassword(),
    }),
  },
] as const satisfies Array<{validationSchema: z.ZodObject}>

export enum EPage {
  DETAILS,
  PASSWORD,
}

export const mergedValidationSchema = steps[EPage.DETAILS].validationSchema.merge(
  steps[EPage.PASSWORD].validationSchema
)
